import React from 'react'
import {connect} from 'react-redux'
import Config from '../../config'
import {renderMoney} from '../../utils'
import { Dialog } from 'react-weui'


class WalletNewInfo extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isShowAlert: false,
        }
    }

    handleTestNew() {
        if (this.props.account.id <= 10){
            location.assign('/wallet/withdraw_apply')
        }else {
            window.location.href = Config.MAIN_URL + '/pay/withdraw_apply'
        }
    }

    onClickWithdraw () {
        if (this.props.moneyInfo.is_balance_frozen) {
            return this.setState({ isShowAlert: true })
        }
        window.location.href = Config.MAIN_URL + '/pay/withdraw_apply'
    }

    render() {
        const {moneyInfo} = this.props;
        return (
            <div className="wallet-new-page-info">
                <div className="info-message">
                    <div className="message-total">
                        <p>昨日收益 (元)</p>
                        <p>{renderMoney(moneyInfo.yesterday_earn)}</p>
                    </div>
                    <div className="message-today">
                        <p>今日收益 (元)</p>
                        <p>{renderMoney(moneyInfo.today_earn)}</p>
                    </div>
                </div>
                <div className="info-button" onClick={e => this.onClickWithdraw()}>
                    提现
                </div>
                <Dialog type="ios" title='提现受限' buttons={[
                    { label: '取消', type: 'default', onClick: () => this.setState({ isShowAlert: false }) },
                    { label: '帮助', onClick: () => location.assign('https://mp.weixin.qq.com/s/cloWIq34FvSqhIpQudq-Ug') }
                ]} show={this.state.isShowAlert}>
                    {moneyInfo.balance_frozen_msg}
                </Dialog>
            </div>
        )
    }
}

export default connect((state) => ({
    account: state.account,
}))(WalletNewInfo)



// WEBPACK FOOTER //
// ./src/components/wallet/WalletNewInfo.js